'use client'

import { Button } from '@/components/ui/button'
import { StickyBanner } from '@/components/ui/sticky-banner'
import { fetchPaymentPortal } from '@/lib/api'

import { useGetUserQuotaQuery } from '@/lib/features/user/userApi'
import { toast } from 'react-toastify'

export const PaymentErrorBanner = () => {
  const { data: quota, isLoading: quotaLoading, error: quotaError } = useGetUserQuotaQuery()

  if (quotaLoading || quotaError || !quota) {
    return null
  }

  if (!quota.subscription.errorMsg) {
    return null
  }

  const handleClick = async () => {
    const portalUrl = await fetchPaymentPortal(window.location.pathname)

    if (portalUrl) {
      window.location.href = portalUrl
    } else {
      toast.error('Oops! Something went wrong!')
    }
  }

  return (
    <StickyBanner className="absolute left-0 right-0 top-0 bg-[#f6c2c4]">
      <div className="flex w-full items-center justify-between">
        <p className="flex-1 text-center">{quota.subscription.errorMsg}</p>
        <Button
          className="mr-6 rounded-xl bg-black px-4 py-1 text-white shadow-sm hover:bg-black/80"
          onClick={handleClick}
        >
          Go to billing
        </Button>
      </div>
    </StickyBanner>
  )
}

export default PaymentErrorBanner
